/**
 * Перечисление типов времени в системе
 */
export enum TimeFormat {
  Z = 'Z', // UTC +0
  L = 'L' // Локальное время установленное пользователем системы
}